export const DEV_SEED_EMAIL_DOMAINS: readonly string[] = ['arya.test', 'arya-properties.test'];

const SEED_DOMAINS: ReadonlySet<string> = new Set(DEV_SEED_EMAIL_DOMAINS);

export const isDevSeedMxDomain = (domain: string): boolean => SEED_DOMAINS.has(domain.trim().toLowerCase());
